import {
  REQUEST_PARTNER,
  REQUEST_PARTNER_LIST,
  REQUEST_PARTNER_LIST_FOR_CREATE
} from './mutation-types'

export default {
  [REQUEST_PARTNER_LIST](state, receivedData) {
    state.partnerList = receivedData.content;
    state.partnerListCount = receivedData.totalElements;
  },
  [REQUEST_PARTNER](state, receivedData) {
    state.partner = receivedData
  },
  [REQUEST_PARTNER_LIST_FOR_CREATE](state, receivedData) {
    state.partnerListForCreate = receivedData;
  }
}